import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.851 4.353a1.204 1.204 0 00-1.702 0l-6.796 6.796c-.47.47-.47 1.232 0 1.702l6.796 6.796c.47.47 1.232.47 1.702 0l6.796-6.796c.47-.47.47-1.232 0-1.702l-6.796-6.796zm1.414-1.415l6.797 6.797a3.204 3.204 0 010 4.53l-6.797 6.797a3.204 3.204 0 01-4.53 0l-6.797-6.797a3.204 3.204 0 010-4.53l6.797-6.797a3.204 3.204 0 014.53 0zm.736 6.648L16.414 11 11 16.408l-3.414-3.413L9 11.58l2 2 4.001-3.994z"
    />
  </svg>
);
